import { TruckCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/truck_events_pb';
import { TruckStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/truck_pb';
import {
  BadgeField,
  Col,
  FieldDisplay,
  IDField,
  ThemeColor,
} from '@rematter/ui-web';

import { truckStatusLabels } from '../enumLabels';

const getStatusColor = (status: TruckStatus): ThemeColor => {
  switch (status) {
    case TruckStatus.AVAILABLE:
      return 'success';
    case TruckStatus.IN_USE:
      return 'teal';
    case TruckStatus.INACTIVE:
      return 'neutral';
    case TruckStatus.OUT_OF_SERVICE:
      return 'warning';
    default:
      return 'neutral';
  }
};

type TruckCreatedDetailProps = {
  event: TruckCreatedEvent;
};

export const TruckCreatedDetail = ({ event }: TruckCreatedDetailProps) => {
  const truck = event.truck;

  if (!truck) {
    return (
      <Col className="@TruckCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@TruckCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Truck Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={truck.id?.value} />
          <FieldDisplay label="License Plate" value={truck.licensePlate} />
          <BadgeField
            label="Status"
            value={truckStatusLabels[truck.status]}
            color={getStatusColor(truck.status)}
          />
          <FieldDisplay label="VIN" value={truck.vin} />
          <FieldDisplay label="Model" value={truck.model} />
          <FieldDisplay
            label="Capacity"
            value={truck.capacity ? String(truck.capacity) : ''}
          />
          <FieldDisplay label="Country" value={truck.country} />
          <FieldDisplay label="State" value={truck.state} />
        </div>
      </Col>
    </Col>
  );
};
